import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TipoRevisionCreateComponent } from './tipo-revision-create/tipo-revision-create.component';
import { TipoRevisionUpdateComponent } from './tipo-revision-update/tipo-revision-update.component';
import { TipoRevisionViewComponent } from './tipo-revision-view/tipo-revision-view.component';
import { TipoRevisionIndexComponent } from './tipo-revision-index/tipo-revision-index.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgSelectModule } from '@ng-select/ng-select';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: 'index', component: TipoRevisionIndexComponent},
  { path: '', redirectTo: 'index', pathMatch: 'full' },
];

@NgModule({
  declarations: [
    TipoRevisionCreateComponent,
    TipoRevisionUpdateComponent,
    TipoRevisionViewComponent,
    TipoRevisionIndexComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    NgxKuvToolsModule,
    NgxKuvUtilsModule,
    NgSelectModule
  ]
})
export class TipoRevisionModule { }
